import { IcIllustEventAftercardPackage, IcIllustMypagePoint } from '@healingpaper/cell-icons'
import { RewardType, type UserServiceOfferDetails } from '@unni/api-client/contracts/service-offer'

import FlexRow from '@/components/shared/FlexRow'
import FlexCol from '@/components/shared/FlexCol'
import { cn } from '@/shared/utils'
import { useLocales } from '@/shared/hooks/useLocales'
import { Languages } from '@/utils/language'
import { Collapse } from '@/shared/components/collapse'

const Rewards = ({
  rewards,
  onTitleClick,
}: {
  rewards: UserServiceOfferDetails['rewards']
  onTitleClick: () => void
}) => {
  const { totalReward, rewardDetails } = rewards || {}

  if (!totalReward || !rewardDetails) return null

  return (
    <Collapse
      title={
        <FlexRow gap={8}>
          {totalReward.isVoucherType ? (
            <IcIllustEventAftercardPackage width={20} height={20} />
          ) : (
            <IcIllustMypagePoint />
          )}

          <FlexRow gap={4}>
            {totalReward.descriptions.map(({ text, highlight }) => (
              <span
                key={text}
                className={cn('typo-subTitle1Bold text-typography-primary', highlight && 'text-orange-500')}
              >
                {text}
              </span>
            ))}
          </FlexRow>
        </FlexRow>
      }
      onTitleClick={onTitleClick}
    >
      <FlexCol gap={24} px={16} py={16} className={cn('bg-gray-200 rounded-2xl text-typography-primary')}>
        {rewardDetails.map((rewardDetail) => {
          return <RewardDetail key={rewardDetail.title} rewardDetail={rewardDetail} />
        })}
      </FlexCol>
    </Collapse>
  )
}

const RewardDetail = ({
  rewardDetail,
}: {
  rewardDetail: {
    title: string
    descriptions: {
      condition: string
      amount: string
    }[]
    type: RewardType
  }
}) => {
  const { language } = useLocales()
  const isKorean = language === Languages.KO
  const isPaymentReward = rewardDetail.type === RewardType.PAYMENT
  const title = isPaymentReward && isKorean ? '앱에서 결제 시 적립 포인트' : rewardDetail.title

  return (
    <FlexCol gap={16}>
      <FlexRow className="typo-subTitle1Medium">{title}</FlexRow>
      <FlexCol gap={4} elementType="ul">
        {rewardDetail.descriptions.map(({ condition, amount }) => (
          <FlexRow items="center" justify="space-between" full key={condition}>
            <Ellipse className="mx-2" />
            <span className="typo-body1Regular flex-1">{condition}</span>
            <span className="typo-body1Medium text-orange-500">{amount}</span>
          </FlexRow>
        ))}
      </FlexCol>
    </FlexCol>
  )
}

const Ellipse = ({ className }: { className?: string }) => {
  return <div className={cn('w-[3px] h-[3px] bg-gray-600 rounded-full', className)} />
}

export default Rewards
